import connectToStores from 'alt-utils/lib/connectToStores'
import { Router, Route, Redirect, browserHistory } from 'react-router'
import {
  Header,
  UpgradeToPlus,
  ManagePlus,
  GetItFixed,
  CreateAnonymousUser,
  SearchTrendsPage
} from 'components'
import { WWW_BASE, API_BASE } from 'consts'
import { UserActions, UserStore, Analytics, Enum } from 'common-frontend'

import {
  AppContainer,
  AdminContainer,
  SetupContainer,
  DetailsContainer,
  ChecksContainer,
  ChargeContainer,
  ShopifyLoginContainer,
  UnsubscribedContainer,
  AuthenticateContainer,
  ManagePlusContainer,
  AppLinkContainer,
  SERPPreviewContainer,
  SEOSettingsContainer,
  OnboardingContainer,
  SetupSurveyContainer,
  TitleDescriptionContainer,
  StructuredDataContainer,
  PlusSettingsContainer,
  EditSearchConsoleContainer,
  OnboardingTemplatesContainer,
  OnboardingInstallContainer,
  OnboardingShowcaseContainer
} from './containers'

export default class Routes extends React.Component {
  requireAuth(nextState, replace) {
    if (!UserStore.getState().authenticated) replace('/users/sign_in')
  }

  requireShopifyAuth(nextState, replace) {
    const shop = nextState.location.query.shop
    const { authenticated, currentUser } = UserStore.getState()

    if (
      !authenticated ||
      currentUser.provider !== 'shopify' ||
      shop !== currentUser.shop
    ) {
      const { query } = nextState.location
      let queryString = Object.keys(query)
        .map(key => `${key}=${query[key]}`)
        .join('&')

      window.location.replace(`${API_BASE}/login?${queryString}`) // Shopify login page served from the API
    }
  }

  goHomeIfAuthenticated(nextState, replace) {
    if (UserStore.getState().authenticated) replace('/checks')
  }

  goHomeOrToSignIn(nextState, replace) {
    if (UserStore.getState().authenticated) replace('/checks')
    else replace('/users/sign_in')
  }

  signOutIfSignedIn() {
    if (UserStore.getState().authenticated) UserActions.signout()
  }

  signOutAndGoToWWW() {
    if (UserStore.getState().authenticated) {
      UserActions.signout() // potential bug... what if this call doesn't complete before window.location is changed?
      window.location = WWW_BASE
    } else {
      window.location = WWW_BASE
    }
  }

  goToAPIBase() {
    window.location = `${API_BASE}/login`
  }

  redirectToDashboard = (nextState, replace) => {
    replace('/checks')
  }

  goToPlusUpgradeOr = route => (nextState, replace) => {
    if (!UserStore.getState().authenticated) replace('/users/sign_in')
    else if (
      this.migrationSafeActiveCharge(UserStore.getState().currentUser) ===
        true &&
      nextState.location.pathname !== route
    )
      replace(route)
    else if (
      this.migrationSafeActiveCharge(UserStore.getState().currentUser) ===
        false &&
      nextState.location.pathname !== '/plus/upgrade'
    )
      replace('/plus/upgrade')

    window.scrollTo(0, 0)
  }

  goToPlusUpgradeOrManage(nextState, replace) {
    if (!UserStore.getState().authenticated) replace('/users/sign_in')
    else if (
      this.migrationSafeActiveCharge(UserStore.getState().currentUser) ===
        true &&
      nextState.location.pathname !== '/plus/manage'
    )
      replace('/plus/manage')
    else if (
      this.migrationSafeActiveCharge(UserStore.getState().currentUser) ===
        false &&
      nextState.location.pathname !== '/plus/upgrade'
    )
      replace('/plus/upgrade')

    window.scrollTo(0, 0)
  }

  goToPlusUpgradeOrTrends(nextState, replace) {
    if (!UserStore.getState().authenticated) replace('/users/sign_in')
    else if (
      this.migrationSafeActiveCharge(UserStore.getState().currentUser) ===
        true &&
      nextState.location.pathname !== '/plus/trends'
    )
      replace('/plus/trends')
    else if (
      this.migrationSafeActiveCharge(UserStore.getState().currentUser) ===
        false &&
      nextState.location.pathname !== '/plus/upgrade'
    )
      replace('/plus/upgrade')

    window.scrollTo(0, 0)
  }

  goToSurveyOrContinue(nextState, replace) {
    if (!UserStore.getState().authenticated) replace('/users/sign_in')
    else if (nextState.location.pathname === '/charge/succeed')
      replace('/survey')
  }

  migrationSafeActiveCharge(currentUser) {
    // We have renamed plus to activeCharge. Since we store currentUser in local storage, there could
    //  be some users who go directly to the app and have plus but not activeCharge. This patch is to support
    //  them until they eventually log in from Shopify again, refreshing their local storage currentUser.
    if (
      currentUser.plus !== undefined &&
      currentUser.activeCharge === undefined
    ) {
      return currentUser.plus
    } else {
      return currentUser.activeCharge
    }
  }

  render() {
    return (
      <Router history={browserHistory}>
        <Route component={AppContainer}>
          <Route
            path="/"
            components={{ content: null }}
            onEnter={::this.goHomeOrToSignIn}
          />
          <Route
            path="/welcome"
            components={{ header: null, content: OnboardingContainer }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/survey"
            components={{ header: null, content: SetupSurveyContainer }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/checks"
            components={{ content: ChecksContainer }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/checks/seoproblems"
            components={{
              content: props => (
                <DetailsContainer
                  params={{ key: 'seoproblems' }}
                  location={props.location}
                />
              )
            }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/checks/notfound"
            components={{
              content: props => (
                <DetailsContainer
                  params={{ key: 'notfound' }}
                  location={props.location}
                />
              )
            }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/checks/blog"
            components={{
              content: props => (
                <DetailsContainer
                  params={{ key: 'blog' }}
                  location={props.location}
                />
              )
            }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/checks/setup/:key"
            components={{ content: SetupContainer }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/users/sign_in"
            components={{ content: null }}
            onEnter={::this.goToAPIBase}
          />
          <Route
            path="/users/sign_up"
            components={{
              header: null,
              content: props => (
                <AuthenticateContainer
                  initialMode={Enum.authenticateMode.SignUp}
                  location={props.location}
                />
              ),
              footer: null
            }}
            onEnter={::Analytics.hideLiveChat}
            onLeave={::Analytics.showLiveChat}
          />
          <Route
            path="/users/create_password"
            components={{
              header: null,
              content: props => (
                <AuthenticateContainer
                  initialMode={Enum.authenticateMode.ForgottenPassword}
                  location={props.location}
                />
              ),
              footer: null
            }}
            onEnter={::Analytics.hideLiveChat}
            onLeave={::Analytics.showLiveChat}
          />
          <Route
            path="/users/change_passwords/:resetToken"
            components={{
              header: null,
              content: props => (
                <AuthenticateContainer
                  initialMode={Enum.authenticateMode.ChangePassword}
                  location={props.location}
                  resetToken={props.params.resetToken}
                />
              ),
              footer: null
            }}
            onEnter={::Analytics.hideLiveChat}
            onLeave={::Analytics.showLiveChat}
          />
          <Route
            path="/users/sign_out"
            components={{ content: null }}
            onEnter={::this.signOutAndGoToWWW}
          />
          <Route
            path="/users/anon"
            components={{ content: CreateAnonymousUser, footer: null }}
            onEnter={::this.signOutIfSignedIn}
          />
          <Route
            path="/charge/:event"
            components={{ content: ChargeContainer }}
            onEnter={::this.goToSurveyOrContinue}
          />
          <Route
            path="/users/sign_in/shopify/:token"
            components={{
              header: null,
              content: ShopifyLoginContainer,
              footer: null
            }}
            onEnter={::this.signOutIfSignedIn}
          />
          <Route
            path="/get-it-fixed"
            components={{ content: GetItFixed }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/plus/upgrade"
            components={{ content: UpgradeToPlus }}
            onEnter={::this.goToPlusUpgradeOrManage}
          />
          <Route
            path="/plus/manage"
            components={{ content: ManagePlusContainer }}
            onEnter={::this.redirectToDashboard}
          />
          <Route
            path="/plus/manage/:resource"
            components={{ content: SEOSettingsContainer }}
            onEnter={::this.redirectToDashboard}
          />
          <Route
            path="/plus/trends"
            components={{ content: SearchTrendsPage }}
            onEnter={::this.goToPlusUpgradeOrTrends}
          />
          <Route
            path="/plus/trends/settings"
            components={{ content: EditSearchConsoleContainer }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/plus/title-description"
            exact
            components={{ content: TitleDescriptionContainer }}
            onEnter={this.goToPlusUpgradeOr('/plus/title-description')}
          />
          <Route
            path="/plus/title-description/settings"
            exact
            components={{ content: PlusSettingsContainer }}
            onEnter={this.goToPlusUpgradeOr('/plus/title-description/settings')}
          />
          <Route
            path="/plus/structured-data"
            components={{ content: StructuredDataContainer }}
            onEnter={this.goToPlusUpgradeOr('/plus/structured-data')}
          />
          <Route
            path="/unsubscribed"
            components={{
              header: Header,
              nav: null,
              content: UnsubscribedContainer
            }}
          />
          <Router
            path="/checks/seoproblems/applink"
            components={{ content: AppLinkContainer }}
            onEnter={::this.requireShopifyAuth}
          />
          <Route
            path="/serppreview"
            components={{
              header: null,
              content: SERPPreviewContainer,
              footer: null
            }}
          />
          <Route
            path="/admin"
            components={{ content: AdminContainer }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/setup/:key"
            components={{ header: null, content: OnboardingTemplatesContainer }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/install/:key"
            components={{ header: null, content: OnboardingInstallContainer }}
            onEnter={::this.requireAuth}
          />
          <Route
            path="/templates"
            components={{ header: null, content: OnboardingShowcaseContainer }}
            onEnter={::this.requireAuth}
          />
        </Route>
      </Router>
    )
  }
}


// WEBPACK FOOTER //
// ./app/routes.js